import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  policyLabel: {
    opacity: 0.6,
    color: theme.colors.light_text,
    ...reskinStyles(theme, { color: 'inherit' })
  },
  tableContainer: {
    boxShadow: 'none'
  }
});

export default makeStyles(styles);
